import { useNavigate } from '@tanstack/react-router';
import { TracingContactSummaryDto } from '../../../../api/generated/model';
import { MasterdataTable } from '../../../masterdata/components/tables/MasterTable.tsx';
import { TracingContactsTableHeader } from './TracingContactsTableHeader.tsx';
import { TracingContactsTableRow } from './TracingContactsTableRow.tsx';

export function TracingContactsTable({
  contacts,
  contactsCount,
  isLoading,
  allContactsCount,
  page,
  totalPages,
  onPrevPage,
  onNextPage,
  showPatientColumn,
}: {
  // The contacts of the current page.
  contacts: TracingContactSummaryDto[];
  // All contacts matching the filters, on every page.
  contactsCount: number;
  isLoading: boolean;
  allContactsCount: number;
  page: number;
  totalPages: number;
  onPrevPage: () => void;
  onNextPage: () => void;
  showPatientColumn: boolean;
}) {
  const navigate = useNavigate();
  const colSpan = showPatientColumn ? 15 : 14;

  return (
    <MasterdataTable
      title={`${contactsCount} Kontaktperson(en)`}
      isLoading={isLoading}
      isEmpty={contacts.length === 0}
      emptyText={
        !allContactsCount ? 'Keine Kontakte vorhanden.' : 'Für diese Kriterien konnten keine Kontakte gefunden werden.'
      }
      colSpan={colSpan}
      page={page}
      totalPages={totalPages}
      onPrevPage={onPrevPage}
      onNextPage={onNextPage}
      disablePrev={page === 0}
      disableNext={page + 1 >= totalPages}
      header={<TracingContactsTableHeader showPatientColumn={showPatientColumn} />}>
      {contacts.map((contact) => (
        <tr
          key={contact.tracingContactId}
          onClick={() =>
            navigate({ to: '/contact-tracing/$patientId', params: { patientId: contact.tracingContactId } })
          }
          style={{ cursor: 'pointer' }}>
          <TracingContactsTableRow contact={contact} showPatientColumn={showPatientColumn} />
        </tr>
      ))}
    </MasterdataTable>
  );
}
